import GlobalBreadcrumbsMixin from '../../Mixins/GlobalBreadcrumbsMixin';
import ComponentMixin from '../../Mixins/ComponentMixin';

export default {
  mixins: [GlobalBreadcrumbsMixin, ComponentMixin],

  mounted () {
    this.setBreadcrumb(this.$t("common.settings"));
  }
};
